import React from 'react';
import { Helmet } from 'react-helmet-async';
import constants from '../../config/constants';

/**
 * Adds noindex meta when the app is served from a known staging hostname
 * (see constants.STAGING_HOSTNAMES — PropertyHost staging, PBS-10361).
 */
const NoIndexForStaging = () => {
  if (typeof window === 'undefined') return null;

  const hostname = window.location?.hostname || '';
  const hosts = constants.STAGING_HOSTNAMES || [];
  const isStaging = hosts.some(
    (h) => hostname === h || hostname.endsWith(`.${h}`)
  );

  if (!isStaging) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};

export default NoIndexForStaging;
